import React, { Component } from "react";

class AppliedFilters extends Component {
  constructor(props) {
    super(props);
    this.bindThis();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.onItemClick = this.onItemClick.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
  }

  onItemClick(filterItem) {
    filterItem.selected = false;
    this.props.onFilterRemoved && this.props.onFilterRemoved();
  }

  onClearClick() {
    this.props.filterGroups
      .filter((filterGroup) => this.shouldHandleFilterGroup(filterGroup))
      .forEach((filterGroup) => {
        filterGroup.items.forEach((filter) => (filter.selected = false));
      });

    this.props.onCleared && this.props.onCleared();
  }

  shouldHandleFilterGroup(filterGroup) {
    // Do not handle filter groups of type 1 (FilterButtonCollection)
    if (filterGroup.type == 1) {
      return false;
    }

    // Do not handle filter groups with no id
    if (filterGroup.id == null) {
      return false;
    }

    if (filterGroup.items.filter((item) => item.selected).length == 0) {
      return false;
    }

    return true;
  }

  renderFilterGroup(filterGroup) {
    const seriesList = this.props.series;
    const isSeriesAndHasSeries = filterGroup.id == "SeriesCodes" && seriesList?.length > 0;

    // If we only have one series available for filtering, we always use it.
    // but we don't want to show it as an applied filter.
    if (isSeriesAndHasSeries && seriesList.length === 1) {
      return null;
    }

    return filterGroup.items
      .filter((filter) => filter.selected)
      .map((filter) => {
        return (
          <div className="c-filter-button c-filter-button--applied" key={filter.value}>
            <input type="checkbox" id={filter.value} hidden checked onClick={() => this.onItemClick(filter)} readOnly />
            <label htmlFor={filter.value}>
              {isSeriesAndHasSeries ? seriesList.filter((x) => x.code === filter.text)[0]?.name : filter.text}
            </label>
          </div>
        );
      });
  }

  render() {
    let filterGroupsToRender = this.props.filterGroups.filter((filterGroup) =>
      this.shouldHandleFilterGroup(filterGroup)
    );

    if (filterGroupsToRender.length == 0) {
      return null;
    }

    return (
      <div className="c-product-overview__section c-product-overview__section--applied">
        <h4 className="c-product-overview__heading">{i18n.getString("appliedfilters.title")}</h4>
        <div className="c-product-overview__outer">
          {filterGroupsToRender.map((filterGroup) => {
            return this.renderFilterGroup(filterGroup);
          })}
          <a
            className="c-product-overview__clear"
            onClick={this.onClearClick}
            style={{ cursor: "pointer" }}
            role="button"
          >
            {i18n.getString("appliedfilters.clear")}
          </a>
        </div>
      </div>
    );
  }
}

export default AppliedFilters;
